export default {
      id: "icon-star-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "icons.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }